<template>
  <div class="bg-white border border-gray-200 rounded-r rounded-bl flex-1 overflow-y-auto focus:outline-none">
    <div class="relative mx-2 md:px-8">
      <div class="pt-10 pb-16">
        <div class="px-4 sm:px-6 md:px-0">
          <h1 class="text-3xl font-extrabold text-gray-900">
            Team settings
            <span
              v-if="team.personal_team === 1"
              class="inline-flex items-center px-2.5 py-0.5 rounded-md text-sm font-medium bg-purple-100 text-purple-800"
            >Personal Team</span>
          </h1>
        </div>
        <div class="px-4 sm:px-6 md:px-0">
          <div class="py-6">
            <!-- Tabs -->
            <div>
              <div class="border-b border-gray-200">
                <nav class="-mb-px flex space-x-8">
                  <tab-link
                    :href="route('teams.settings', {team: team})"
                    :active="route().current('teams.settings')"
                  >
                    General
                  </tab-link>
                  <tab-link
                    :href="route('teams.settings.profile', {team: team})"
                    :active="route().current('teams.settings.profile')"
                  >
                    Profile
                  </tab-link>
                  <tab-link
                    :href="route('teams.settings.members', {team: team})"
                    :active="route().current('teams.settings.members')"
                  >
                    Members
                  </tab-link>
                  <tab-link
                    v-if="team.personal_team === 0 && can('view team plan')"
                    :href="route('teams.settings.plan', {team: team})"
                    :active="route().current('teams.settings.plan')"
                  >
                    Plan
                  </tab-link>
                  <tab-link
                    v-if="team.personal_team === 0 && can('view team billing')"
                    :href="route('teams.settings.billing', {team: team})"
                    :active="route().current('teams.settings.billing')"
                  >
                    Billing
                  </tab-link>
                </nav>
              </div>
            </div>

            <!-- Tab content sections -->
            <slot />
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import TabLink from '../../../ComponentsDeprecated/TabLink.vue';

export default {
  components: {
    TabLink,
  },
  props: {
    team: {
      type: Object,
      required: true,
    },
  },
};
</script>
<style lang="scss" scoped>
.router-link-exact-active {
  @apply border-purple-500 text-purple-600;
}
</style>
